const listeners = new Set()
const bufferedEvents = []

function emit(event) {
  if (!listeners.size) {
    bufferedEvents.push(event)
    return
  }
  listeners.forEach(listener => listener(event))
}

function normalizeMessage(message) {
  if (message instanceof Error) return message.message
  if (message === null || message === undefined) return ""
  return String(message)
}

function toast(type, message, options = {}) {
  emit({
    kind: "toast",
    type,
    message: normalizeMessage(message),
    duration: options.duration,
    closable: options.showClose !== false
  })
}

function openDialog(mode, message, title = "", options = {}) {
  return new Promise((resolve, reject) => {
    emit({
      kind: "dialog",
      mode,
      type: options.type || (mode === "alert" ? "info" : "warning"),
      title: normalizeMessage(title),
      message: normalizeMessage(message),
      confirmButtonText: options.confirmButtonText || "",
      cancelButtonText: options.cancelButtonText || "",
      showCancelButton: mode === "confirm",
      closeOnClickModal: options.closeOnClickModal !== false,
      resolve,
      reject
    })
  })
}

const notice = {
  success(message, options) {
    toast("success", message, options)
  },
  error(message, options) {
    toast("error", message, options)
  },
  warning(message, options) {
    toast("warning", message, options)
  },
  info(message, options) {
    toast("info", message, options)
  },
  confirm(message, title, options) {
    if (title && typeof title === "object") return openDialog("confirm", message, "", title)
    return openDialog("confirm", message, title, options)
  },
  alert(message, title, options) {
    if (title && typeof title === "object") return openDialog("alert", message, "", title)
    return openDialog("alert", message, title, options)
  },
  subscribe(listener) {
    listeners.add(listener)
    bufferedEvents.splice(0).forEach(event => listener(event))
    return () => listeners.delete(listener)
  }
}

export default notice

export const NoticePlugin = {
  install(Vue) {
    Vue.prototype.$notice = notice

    // 兼容既有页面调用，新提示不再使用 Element UI 的 Message 和 MessageBox 外观。
    Vue.prototype.$message = notice
    Vue.prototype.$confirm = notice.confirm
    Vue.prototype.$alert = notice.alert
  }
}
